import React from 'react'
import { Box } from '@mui/material'
import { BarChart } from '@mui/icons-material'

const Analytics: React.FC = () => {
  return (
    <Box sx={{ maxWidth: '1280px', mx: 'auto' }}>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Box component="h1" sx={{ fontSize: '1.875rem', fontWeight: 'bold', color: 'text.primary', mb: 1 }}>
          Analytics
        </Box>
        <Box component="p" sx={{ color: 'text.secondary' }}>
          Track and analyze platform performance metrics
        </Box>
      </Box>

      {/* Coming Soon Card */}
      <Box sx={{ 
        bgcolor: 'background.paper', 
        borderRadius: 2, 
        boxShadow: 1, 
        p: 6, 
        textAlign: 'center' 
      }}>
        <Box sx={{ 
          display: 'inline-flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          width: 96, 
          height: 96, 
          bgcolor: 'primary.lighter',
          borderRadius: '50%', 
          mb: 3 
        }}>
          <BarChart sx={{ fontSize: 48, color: 'primary.main' }} />
        </Box>
        <Box component="h2" sx={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'text.primary', mb: 2 }}>
          Analytics Feature Coming Soon
        </Box>
        <Box component="p" sx={{ color: 'text.secondary', maxWidth: 800, mx: 'auto', mb: 3 }}>
          We're working on bringing you a comprehensive analytics dashboard to help you track platform 
          performance, user engagement, sales metrics, and generate actionable insights with interactive 
          charts and visualizations.
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center', fontSize: '0.875rem', color: 'text.secondary' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box component="span" sx={{ color: 'success.main' }}>✓</Box>
            <span>Performance Dashboards</span>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box component="span" sx={{ color: 'success.main' }}>✓</Box>
            <span>User Engagement</span>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box component="span" sx={{ color: 'success.main' }}>✓</Box>
            <span>Sales Analytics</span>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box component="span" sx={{ color: 'success.main' }}>✓</Box>
            <span>Data Visualization</span>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Analytics
